// extracted by mini-css-extract-plugin
export default {"category":"budget-table-subcategory_category__aL3GQ"};